import React from 'react'
import ReactDataGrid from 'react-data-grid'
import * as FormManager from 'fw/forms/form/FormManager'
import * as Notifications from 'fw/globals/Notifications';
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

class SetupList extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        let  columns = this.props.columns.filter(x => !x.hidden);

        columns = columns.map(function (c) {
            return Object.assign({ resizable: true }, c);
        });

        return {
            selectedIndexes: [],
            list: props.list,
            columns: columns,
            message: 'Loading...'
        }
    }

    select = (rowIdx, row) => {
        this.setState({ selectedIndexes: [rowIdx] });
        this.props.onSelect(row[this.props.rowKey]);
    }

    unSelect = () => {
        this.setState({ selectedIndexes: [] });
    }

    getSelectedIndexes = () => {
        return this.state.selectedIndexes;
    }

    rowGetter = (i) => {
        return this.props.list.items[i];
    }

    getRowsByIndexes = (indexes) => {
        let selectedRows = [];
        indexes.forEach(i => {
            selectedRows.push(this.props.list.items[i]);
        });

        return selectedRows;
    }

    onRowsSelected = (rows) => {
        let selection = this.state.selectedIndexes.concat(rows.map(r => r.rowIdx));
        if (this.props.maxRowSelection === 0 || (rows.length + this.state.selectedIndexes.length) <= this.props.maxRowSelection){
            this.setState({ selectedIndexes: selection });
            if (this.props.onRowsSelectedChange){
                this.props.onRowsSelectedChange(this.getRowsByIndexes(selection));
            }
        }
        else
            Notifications.error(this.props.maxRowSelectionReachedMessage);
    };
    
    onRowsDeselected = (rows) => {
        let rowIndexes = rows.map(r => r.rowIdx);
        let selection = this.state.selectedIndexes.filter(i => rowIndexes.indexOf(i) === -1);
        this.setState({ selectedIndexes: selection });
        if (this.props.onRowsSelectedChange){
            this.props.onRowsSelectedChange(this.getRowsByIndexes(selection));
        }
    };

    clearRowsSelected = () => {
        this.setState({ selectedIndexes: [] });
        if (this.props.onRowsSelectedChange){
            this.props.onRowsSelectedChange([]);
        }
    }

    // Handlers
    handleRowClick = (rowIdx, row) => {
        const me = this;

        if (rowIdx < 0)
            return;

        FormManager.checkUnsavedChanges(function () {
            me.select(rowIdx, row);
        })
    }

    handleSort = (sortColumn, sortDirection) => {
        this.props.onSort(sortColumn, sortDirection);
    }

    componentWillMount() {
        if (!this.props.triggerInitialSearch)
            this.setState({ message: '' });
    }

    componentWillReceiveProps(nextProps, nextState) {
        if (nextProps.filters !== this.props.filters || 
            nextProps.sortField !== this.props.sortField || 
            nextProps.sortDirection !== this.props.sortDirection){
            this.clearRowsSelected();
        }
        if (nextProps.columns !== this.props.columns)
            this.setState({
                columns: nextProps.columns.filter(x => !x.hidden)
            });
    }

    // React
    render() {
        if (this.props.list === null)
            return (<div>{this.state.message}</div>);

        const rowSelectionTooltip = (
            <Tooltip id='rowSelectionTooltip'>
                {this.props.rowSelectionTooltip ? this.props.rowSelectionTooltip : ""}
            </Tooltip>
        )
        const rowText = this.state.selectedIndexes.length === 1 ? "row" : "rows";

        return (
            <div id="divSetupGrid" className="react-grid-stripped">
                {this.props.enableRowSelection ?
                    <React.Fragment>
                        <span>
                            {this.state.selectedIndexes.length} {rowText} selected
                        </span>
                        &nbsp;&nbsp;
                        {this.props.rowSelectionTooltip ? 
                            <OverlayTrigger placement="right" overlay={rowSelectionTooltip}>
                                <FontAwesomeIcon icon={faInfoCircle} size="1x" className="tooltipIcon" />
                            </OverlayTrigger>
                        :null}
                    </React.Fragment>
                :null}
                <ReactDataGrid
                    rowKey={this.props.rowKey}
                    columns={this.state.columns}
                    rowGetter={this.rowGetter}
                    rowsCount={this.props.list.count}
                    minHeight={this.props.height}
                    onRowClick={this.handleRowClick}
                    onGridSort={this.handleSort}
                    enableCellSelect={false}
                    rowSelection={{
                        showCheckbox: this.props.enableRowSelection,
                        enableShiftSelect: this.props.enableRowSelection,
                        onRowsSelected: this.onRowsSelected,
                        onRowsDeselected: this.onRowsDeselected,
                        selectBy: { indexes: this.state.selectedIndexes }
                    }} />
            </div>
        );
    }
}

SetupList.defaultProps = {
    height: 500,
    enableRowSelection: false,
    maxRowSelection: 0,
    maxRowSelectionReachedMessage: "Maximun number of selections allowed reached.",
    rowSelectionTooltip: null
};

export default SetupList;



// WEBPACK FOOTER //
// ./src/areas/shared/pages/setup/SetupList.js